
<lib-ags-loading *ngIf="loading"></lib-ags-loading>
<div class="card list-element" *ngIf="loading === false">
  <kendo-grid
    #grid
    [data]="gridView"
    [resizable]="true"
    [reorderable]="true"
    [columnMenu]="true"
    [pageable]="true"
    [pageSize]="gridSettings.state.take"
    [skip]="gridSettings.state.skip"
    [sortable]="true"
    [sort]="gridSettings.state.sort"
    [filterable]="true"
    [filter]="gridSettings.state.filter"
    [groupable]="true"
    [group]="gridSettings.state.group"
    (dataStateChange)="dataStateChange($event)"
    (columnReorder)="onReorder($event)"
    (columnResize)="onResize($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
  >
    <ng-template kendoGridToolbarTemplate>
      <div class="title">
        {{ titlefield.toUpperCase() }}
      </div>
      <kendo-grid-spacer></kendo-grid-spacer>
      <div class="group-b">
        <button 
          kendoGridExcelCommand 
          [svgIcon]="svgExcel"
        >
          Exporter en Excel
        </button>
        <button kendoButton 
          (click)="clearFilters()"
          [svgIcon]="svgFilterClear"
          title="Supprimer les filtres"
        >
        </button>
      </div>
    </ng-template>
    <kendo-grid-column
      *ngFor="let col of gridSettings.columnsConfig"
      [field]="col.field"
      [title]="col.title"
      [width]="col.width"
      [filter]="col.filter ?? 'text'"
      [filterable]="col.filterable ?? true"
      [hidden]="col.hidden"
      [format]="col.format"
      class="center"
    >
      <ng-template *ngIf="col.format === '{0:dd/MM/yyyy}'" kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-date-filter-cell
            [showOperators]="false"
            [column]="column"
            operator="eq"
            placeholder="JJ/MM/AAAA"
            [filter]="filter"
          >
          </kendo-grid-date-filter-cell> 
      </ng-template>
      <ng-template *ngIf="col.field === 'doc_generated'" kendoGridCellTemplate let-dataItem>
        <a
          class="waves-effect waves-light btn dyn-prim-bg-color"
          *ngIf="dataItem.docGenerated !== null"
          (click)="downloadDoc(dataItem.id)"
        >
          <i class="material-icons middle">save_alt</i>
        </a>
      </ng-template>
      <ng-template *ngIf="col.field === 'edit_button'" kendoGridCellTemplate let-dataItem>
        <button kendoButton 
          (click)="goTo(dataItem.id)"
          [svgIcon]="svgHorizontal"
          title="voir la fiche"
        >
        </button>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-messages
      done="Appliquer"
      filterClearButton="Effacer"
      filterFilterButton="Filtrer"
      filterOrLogic="Ou"
      filterAndLogic="Et"
      columns="Colonnes"
      columnsApply="Appliquer"
      columnsReset="Réinitialiser"
      filter="Filtres"
      filterAnd="Et"
      filterOr="Ou"
      sortAscending="Tri croissant"
      sortDescending="Tri décroissant"
      filterContainsOperator="Contient"
      filterEndsWithOperator="Termine par"
      filterEqOperator="Est égal"
      filterNotEqOperator="N'est pas égal"
      filterNotContainsOperator="Ne contient pas"
      filterStartsWithOperator="Commence par"
      filterIsNullOperator="Est nulle"
      filterIsNotNullOperator="N'est pas nulle"
      filterIsEmptyOperator="Est vide"
      filterIsNotEmptyOperator="N'est pas vide"
      filterDateToday="Aujourd'hui"
      noRecords="Aucun élément trouvé."
      pagerPage="Page"
      pagerOf="sur"
      pagerItems="élément(s)"
      pagerItemsPerPage="élément(s) par page"
      groupPanelEmpty="Faites glisser un en-tête de colonne et déposez-le ici pour regrouper par cette colonne."
      groupChipMenuPrevious="Déplacer avant"
      groupChipMenuNext="Déplacer après"
      [pagerItems]="data.length > 1 ? 'éléments' : 'élément'"
      [pagerItemsPerPage]="data.length > 1 ? 'éléments par page' : 'élément par page'"
    >
    </kendo-grid-messages>
    <kendo-grid-excel
      fileName="liste.xlsx"      
      [fetchData]="allData"
    ></kendo-grid-excel>
    <ng-template
      kendoPagerTemplate
      let-totalPages="totalPages"
      let-currentPage="currentPage"
    >
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons
        [buttonCount]="buttonCount"
      ></kendo-pager-numeric-buttons>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-page-sizes [pageSizes]="sizes"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
</div>
